import { IconTiny } from '@/widgets/components/icon';
import { Button, IconButton } from 'rsuite';
import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  height: '100%';
  width: '100%';
`;

export const StyledTitleText = styled.div`
  font-weight: bold;
  font-size: 16px;
  ::before {
    content: '${(props) => props.title}';
  }
`;

export const StyledSelectedLabel = styled.div`
  color: rgba(0, 0, 0, 0.5);
`;

export const StyledHeaderDivider = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
  height: 1.5px;
`;

export const TitleExitWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CloseIcon = styled(IconTiny)`
  color: #000000;
`;

export const StyledIconButton = styled(IconButton)`
  padding-left: 12px !important;
`;

export const AddChartItemWrapper = styled.div`
  height: 350px;
  overflow-y: scroll;
`;

export const StyledChartItemPair = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledAddButton = styled(Button)`
  &.rs-btn-default {
    color: 'blue';
  }
`;
